"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageWarning = exports.DomainSetupWarning = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _Container = _interopRequireDefault(require("./components/Container"));
var _excluded = ["onUpgrade", "onClose"],
  _excluded2 = ["isAdmin", "goToSettings"];
var WarningBanner = function WarningBanner(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    variant: "warning",
    transparent: transparent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-center font-light text-sm"
  }, children), !(0, _isNil["default"])(onClose) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 w-12 cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], null)));
};
var StorageWarning = exports.StorageWarning = function StorageWarning(_ref2) {
  var onUpgrade = _ref2.onUpgrade,
    onClose = _ref2.onClose,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(WarningBanner, (0, _extends2["default"])({}, props, {
    onClose: onClose
  }), onUpgrade ? t('premium.storage.warningBanner') : t('premium.storage.warningBanner.noUpgrade'), onUpgrade && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-3 font-bold cursor-pointer",
    onClick: onUpgrade
  }, t('premium.storage.warningBanner.upgrade')));
};
var DomainSetupWarning = exports.DomainSetupWarning = function DomainSetupWarning(_ref3) {
  var isAdmin = _ref3.isAdmin,
    goToSettings = _ref3.goToSettings,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(WarningBanner, props, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.customDomain.setup.warning"
  }), ' ', isAdmin ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.customDomain.setup.warning.admin"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold cursor-pointer",
    onClick: goToSettings
  })) : /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.customDomain.setup.warning.subaccount"
  }));
};
//# sourceMappingURL=Warning.js.map